<template>
  <v-container fluid>
    <top-header title="Exports" />
    <v-row>
      <v-col class="text-right">
        <v-btn
          class="mx-3 primary--text"
          color="white"
          to="/backoffice/exportdetails"
          :disabled="!listLoaded"
        >
          <v-icon>mdi-database-plus-outline</v-icon>{{ $t('createExport') }}
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <exports-list
          :fetch-method="fetchMethod"
          details-route="ExportDetailsAdmin"
          @loaded="onListLoaded"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ExportsService from '@/services/ExportsService'
import TopHeader from '@/components/base/TopHeader'
import ExportsList from '@/components/hmd/Exports/ExportsList'

export default {
  name: 'Exports_admin',
  components: {
    TopHeader,
    ExportsList,
  },
  data: () => ({
    listLoaded: false,
  }),
  methods: {
    fetchMethod(page, itemsPerPage, project) {
      return ExportsService.listExportsAdmin(this, page, itemsPerPage, project)
    },
    onListLoaded() {
      this.listLoaded = true
    },
  },
}
</script>
